import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['Hz'] as const;

const validator = AbstractMeasurement.minNomMax
    .extend({
        unit: z.literal('Hz').default('Hz'),
    })
    .default({});

export const Frequency = {
    validator,
    units,
};

export type Frequency = z.infer<typeof validator>;
